import { isAreaInfoNoticeOfInterest } from '@/services/address-search.service'
import { AreaInfoResponse } from '@/types'
import { AreaStatus } from '@/constants/operator'
import { RouteName } from './enum'
import { isAreaStatusUpsellOperatorChangeNoCampaign } from '@/utils/area.utils'

const isAreaStatusOrderEligible = (areaStatusName: AreaStatus) => isAreaStatusUpsellOperatorChangeNoCampaign(areaStatusName)
    || areaStatusName === AreaStatus.SaleInProgress
    || areaStatusName === AreaStatus.BuildingInProgress
const campaignExpired = (areaInfo: AreaInfoResponse) => areaInfo.NoActiveCampaignInArea && !isAreaStatusUpsellOperatorChangeNoCampaign(areaInfo.AreaStatusName)
const statusPage = (areaInfo: AreaInfoResponse) => isAreaStatusOrderEligible(areaInfo.AreaStatusName) && areaInfo.IsCompleted
const orderFlow = (areaInfo: AreaInfoResponse) => isAreaStatusOrderEligible(areaInfo.AreaStatusName) && !areaInfo.IsCompleted

export const getRouteForArea = (areaInfo: AreaInfoResponse) => {
  if (isAreaInfoNoticeOfInterest(areaInfo)) {
    if (areaInfo.IsRegistered) {
      return RouteName.NoticeOfInterestAlreadyRegisteredPage
    }

    return RouteName.NoticeOfInterestAreaPage
  }

  if (statusPage(areaInfo)) {
    return RouteName.StatusPage
  }

  if (campaignExpired(areaInfo)) {
    return RouteName.CampaignExpiredPage
  }

  if (orderFlow(areaInfo)) {
    return RouteName.OrderFlowPage
  }

  return null
}
